/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Shopping_Range_LabelInputs */

const en_shopping_range_label = /** @type {(inputs: Shopping_Range_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Date range: ${i?.from} to ${i?.to}`)
};

const de_shopping_range_label = /** @type {(inputs: Shopping_Range_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeitraum: ${i?.from} bis ${i?.to}`)
};

/**
* | output |
* | --- |
* | "Date range: {from} to {to}" |
*
* @param {Shopping_Range_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_range_label = /** @type {((inputs: Shopping_Range_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Range_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_range_label(inputs)
	return en_shopping_range_label(inputs)
});